import {
  Box,
  Grid,
  FormControl,
  Select,
  MenuItem,
  Button,
  TextField,
  InputLabel,
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { ICompanyDocTradeCivil } from '../../../rest/types';
import moment from 'moment';
import { useCompanyDocumentTradeAndCivilUpdate } from '../../../rest/useCompanyInfo';
import MultipleAndSingleImgValidateWithPreview from '../../../Components/FileValidation/MultipleAndSingleImgValidateWithPreview';
import { showToast } from '../../../Toaster/Toaster';

interface IProps {
  memberId: number;
  companyDocument: ICompanyDocTradeCivil;
}

const UpdateCompanyDocument = ({ companyDocument }: IProps) => {
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    getValues,
    formState: { errors, touchedFields },
    reset,
  } = useForm();

  const [officeAgreement, setOfficeAgreement] = useState<string>(
    companyDocument?.companyDocs?.company_office_agreement
  );
  const [ownershipStatus, setOwnershipStatus] = useState(
    companyDocument?.companyDocs?.company_ownership_status
  );
  const [removeExistFile, setRemoveExistFile] = useState<string[]>([]);
  const [addNewFile, setNewFile] = useState<(string | File)[]>([]);

  const { isLoading, isSuccess, mutate } =
    useCompanyDocumentTradeAndCivilUpdate();

  const onSubmit = () => {
    const touchedValues = Object?.keys(touchedFields)?.reduce((acc, key) => {
      acc[key] = getValues(key); // Get the current value of the touched field
      return acc;
    }, {} as Record<string, any>);

    const formData = new FormData();

    if (removeExistFile?.length) {
      formData.append('remove_office_photos', JSON.stringify(removeExistFile));
    }

    if (addNewFile?.length) {
      addNewFile?.map((file: any) => {
        formData.append('office_photographs', file);
      });
    }
    if (Object?.keys(touchedValues)?.length) {
      Object?.keys(touchedValues)?.forEach((key) => {
        //office_photographs  multiple images so i t handle different way
        if (touchedValues[key] && key !== 'office_photographs') {
          formData.append(
            key,
            typeof touchedValues[key] === 'string'
              ? touchedValues[key]
              : touchedValues[key][0]
          );
        }
      });
      mutate({ data: formData });
    } else {
      showToast(`Field Change First`, 'error');
    }
  };
  useEffect(() => {
    reset({
      ...companyDocument?.companyCivilAviation,
      certificate_issue_date: moment(
        companyDocument?.companyCivilAviation?.certificate_issue_date
      ).format('YYYY-MM-DD'),
      certificate_expiry_date: moment(
        companyDocument?.companyCivilAviation?.certificate_expiry_date
      ).format('YYYY-MM-DD'),
      ...companyDocument?.companyLicense,
      company_trade_license_expiry_date: moment(
        companyDocument?.companyLicense?.company_trade_license_expiry_date
      ).format('YYYY-MM-DD'),
    });
  }, [companyDocument]);
  return (
    <>
      <Box component='form' onSubmit={handleSubmit(onSubmit)} p={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='demo-simple-select-label'>
                Ownership status
              </InputLabel>
              <Select
                {...register('company_ownership_status', {
                  required: 'company_ownership_status is required',
                })}
                labelId='demo-simple-select-label'
                label='Ownership status'
                value={ownershipStatus}
                onChange={(e: any) => setOwnershipStatus(e.target.value)}
              >
                <MenuItem value={'Proprietorship'}>Proprietorship</MenuItem>
                <MenuItem value={'Partnership'}>Partnership</MenuItem>
                <MenuItem value={'Incorporator'}>Incorporator</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {ownershipStatus === 'Partnership' && (
            <Grid item xs={12} md={4}>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Photocopy of deed of partnership ( max size 5mb )'
                fieldName={`company_partnership_deed_file`}
                mode='single'
                imgSerUrl={[
                  companyDocument?.companyDocs?.company_partnership_deed_file,
                ]}
              />
            </Grid>
          )}

          {ownershipStatus === 'Incorporator' && (
            <Grid item xs={12} md={4}>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload incorporation certificate ( max size 5mb )'
                fieldName={`company_incorporation_certificate`}
                mode='single'
                imgSerUrl={[
                  companyDocument?.companyDocs
                    ?.company_incorporation_certificate,
                ]}
              />
            </Grid>
          )}
          {ownershipStatus === 'Incorporator' && (
            <Grid item xs={12} md={4}>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Memorandum document ( max size 5mb )'
                fieldName={`company_memorandum_file`}
                mode='single'
                imgSerUrl={[
                  companyDocument?.companyDocs?.company_memorandum_file,
                ]}
              />
            </Grid>
          )}
          {/* office agreement */}
          <Grid item xs={12} md={4}>
            <FormControl sx={{ width: '100%' }}>
              <InputLabel id='demo-simple-select-label'>
                Office agreement
              </InputLabel>
              <Select
                labelId='demo-simple-select-label'
                label=' Office agreement'
                value={officeAgreement}
                onChange={(e: any) => setOfficeAgreement(e.target.value)}
              >
                <MenuItem value={'Self premise'}>Self premise</MenuItem>
                <MenuItem value={'Rented premise'}>Rented premise</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={4}>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='03 ( Three months) latest bank statement ( max size 5mb )'
              fieldName={`company_bank_statement`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[companyDocument?.companyDocs?.company_bank_statement]}
            />
          </Grid>

          <Grid item xs={12} md={4}>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              hideCustomLabel
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Staff list on office pad with seal and signature of owner ( max size 5mb )'
              fieldName={`company_staff_list_file`}
              imgSerUrl={[
                companyDocument?.companyDocs?.company_staff_list_file,
              ]}
              mode='single'
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <MultipleAndSingleImgValidateWithPreview
              mt='0'
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Undertaking File (Max size 5mb)'
              fieldName={`company_undertaking_file`}
              hideCustomLabel
              onlyPdf
              mode='single'
              imgSerUrl={[
                companyDocument?.companyDocs?.company_undertaking_file,
              ]}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              hideCustomLabel
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Upload internal &#38; external photographs of office ( max size 5mb )'
              fieldName={`office_photographs`}
              imgSerUrl={[
                companyDocument?.companyDocs?.company_office_photographs[0],
                companyDocument?.companyDocs?.company_office_photographs[1],
              ]}
              removeExistingImaFun={(e: string[]) => {
                setRemoveExistFile(e);
              }}
              addNewImagesFun={(e: (string | File)[]) => {
                setNewFile(e);
              }}
              mode='multiple'
            />
          </Grid>
          {officeAgreement && (
            <Grid item xs={12} md={4}>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label={
                  officeAgreement === 'self premise'
                    ? 'Deed of agreement of self premise office space ( max size 5mb )'
                    : 'Deed of agreement of rented premise office space ( max size 5mb )'
                }
                fieldName={`company_agreement_file`}
                mode='single'
                imgSerUrl={[
                  companyDocument?.companyDocs?.company_agreement_file,
                ]}
              />
            </Grid>
          )}
          <Grid item xs={12} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                hideCustomLabel
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label="One staff's GDS (Sabre/Galileo?Amadeus) certificate ( max size 5mb )"
                fieldName={`company_one_staff_certificate`}
                mode='single'
                imgSerUrl={[
                  companyDocument?.companyDocs?.company_one_staff_certificate,
                ]}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='03 ( Three months) latest sales statement ( max size 5mb )'
                fieldName={`company_sales_statement`}
                hideCustomLabel
                mode='single'
                imgSerUrl={[
                  companyDocument?.companyDocs?.company_sales_statement,
                ]}
              />
            </Box>
          </Grid>
        </Grid>

        {/* ------------trade license--------------- */}
        <Grid container spacing={2} mt={3}>
          <Grid item xs={12} className='text-xl text-center text-black'>
            Trade License & TIN Certificate Information
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                label={'Trade license number'}
                id='outlined-basic'
                variant='outlined'
                placeholder='Enter trade license number '
                type='text'
                fullWidth
                {...register('company_trade_license', {
                  required: ' Trade license number is required',
                })}
                error={
                  errors?.company_trade_license &&
                  Boolean(errors.company_trade_license)
                }
                helperText={
                  Boolean(errors?.company_trade_license?.message)
                    ? `${errors?.company_trade_license?.message}`
                    : ''
                }
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                label={'TIN number'}
                id='outlined-basic'
                variant='outlined'
                placeholder='Enter tin number'
                type='number'
                fullWidth
                {...register('company_tin_number', {
                  required: 'TIN number is required',
                })}
                error={
                  errors?.company_tin_number &&
                  Boolean(errors.company_tin_number)
                }
                helperText={
                  Boolean(errors?.company_tin_number?.message)
                    ? `${errors?.company_tin_number?.message}`
                    : ''
                }
              />
            </Box>{' '}
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label='Trade license expiry date'
              id='date'
              type='date'
              required
              {...register('company_trade_license_expiry_date', {
                required: ' Trade license expiry date is required',
              })}
              error={
                errors?.company_trade_license_expiry_date &&
                Boolean(errors.company_trade_license_expiry_date)
              }
              helperText={
                Boolean(errors?.company_trade_license_expiry_date?.message)
                  ? `${errors?.company_trade_license_expiry_date?.message}`
                  : ''
              }
              sx={{ width: '100%' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                hideCustomLabel
                label='Upload BIN File / document ( max size 5mb )'
                fieldName={`company_bin_file`}
                mode='single'
                imgSerUrl={[companyDocument?.companyLicense?.company_bin_file]}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                hideCustomLabel
                label='Proof of Submission of Tax Return (Acknowledgement Receipt) ( max 5mb )'
                fieldName={`company_tin_file`}
                mode='single'
                imgSerUrl={[companyDocument?.companyLicense?.company_tin_file]}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              hideCustomLabel
              label='Upload trade license File / document ( max size 5mb )'
              fieldName={`company_trade_license_file`}
              mode='single'
              imgSerUrl={[
                companyDocument?.companyLicense?.company_trade_license_file,
              ]}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <Box>
              <TextField
                label='Bin number (Business Identification Number)'
                id='outlined-basic'
                variant='outlined'
                placeholder='Enter bin number'
                type='text'
                fullWidth
                {...register('company_bin_number')}
              />
            </Box>
          </Grid>
        </Grid>

        {/* ----------civil aviation---------------------------- */}
        <Grid container spacing={2}>
          <Grid item xs={12} className='text-xl text-center text-black'>
            Civil Aviation Information
          </Grid>

          <Grid item xs={12} md={4}>
            <TextField
              label='Civil aviation tourism certificate number'
              id='outlined-basic'
              required
              variant='outlined'
              placeholder='Enter civil aviation tourism certificate number '
              fullWidth
              {...register('certificate_number', {
                required: 'Tourism certificate number is required',
              })}
              error={
                errors?.certificate_number && Boolean(errors.certificate_number)
              }
              helperText={
                Boolean(errors?.certificate_number?.message)
                  ? `${errors?.certificate_number?.message}`
                  : ''
              }
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <Box>
              <TextField
                label='Civil aviation tourism issue date'
                id='date'
                type='date'
                {...register('certificate_issue_date', {
                  required: 'Civil aviation tourism issue date is required',
                })}
                error={
                  errors?.certificate_issue_date &&
                  Boolean(errors.certificate_issue_date)
                }
                helperText={
                  Boolean(errors?.certificate_issue_date?.message)
                    ? `${errors?.certificate_issue_date?.message}`
                    : ''
                }
                // onChange={(e) =>
                //   setDate({
                //     ...date,
                //     certificate_issue_date: e.target.value,
                //   })
                // }
                sx={{ width: '100%' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <TextField
                label='Civil aviation tourism certificate expiry date'
                id='date'
                type='date'
                {...register('certificate_expiry_date', {
                  required: 'Civil aviation tourism expiry date is required',
                })}
                error={
                  errors?.certificate_expiry_date &&
                  Boolean(errors.certificate_expiry_date)
                }
                helperText={
                  Boolean(errors?.certificate_expiry_date?.message)
                    ? `${errors?.certificate_expiry_date?.message}`
                    : ''
                }
                // onChange={(e) =>
                //   setDate({
                //     ...date,
                //     certificate_expiry_date: e.target.value,
                //   })
                // }
                sx={{ width: '100%' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box>
              <MultipleAndSingleImgValidateWithPreview
                mt={'0'}
                register={register}
                clearErrors={clearErrors}
                setError={setError}
                errors={errors}
                label='Upload civil aviation tourism certificate ( max size 5mb )'
                fieldName={`certificate_file`}
                hideCustomLabel
                imgSerUrl={[
                  companyDocument?.companyCivilAviation?.certificate_file,
                ]}
                mode='single'
              />
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ pt: 5, textAlign: 'end', mb: 2 }}>
          {isLoading ? (
            <Button
              disabled
              variant='contained'
              disableElevation
              className='add-remove-button'
            >
              Loading..
            </Button>
          ) : (
            <Button
              type='submit'
              variant='contained'
              disableElevation
              className='add-remove-button'
            >
              Save
            </Button>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UpdateCompanyDocument;
